import Joi from "joi";

export const login_schema = Joi.object({
  email: Joi.string().email({ minDomainSegments: 2, tlds: false }).required(),
  password: Joi.string().min(8).max(25).required(),
});
